import { Box, BoxProps, Stack, Text } from "@chakra-ui/react";
import { useMemo } from "react";
import { when } from "utils";
import ProgressBar from "./ProgressBar";

interface StepProgressProps extends BoxProps {
  value: number;
  max: number;
}

export function StepProgress(props: StepProgressProps) {
  const { value = 1, max = 3, ...xprops } = props;

  const isCompleted = useMemo(() => value === max, [value, max]);
  return (
    <Stack w="100%" {...xprops}>
      <ProgressBar value={value} max={max} />
      <Box>
        <Text fontSize="13px" fontWeight="bold">
          {when(!isCompleted, `KYC Step ${value}/${max}`, "")}
        </Text>
        {!isCompleted && (
          <Text fontSize="14px" fontWeight="500">
            It takes less than 2 minutes to complete this process
          </Text>
        )}
      </Box>
    </Stack>
  );
}
